module.exports = __webpack_public_path__ + "static/media/first-second-half.svg.5a824782.png";